import { ReactElement, useCallback } from 'react';
import { NavigateFunction } from 'react-router/dist/lib/hooks';
import { useLocation, useNavigate } from 'react-router-dom';
import { DIALOGS } from './constants';

const DIALOG_STATE_KEY = 'dialogName';

type OpenDialogFunction = <TState>(
    modalName: string,
    state?: TState,
) => ReturnType<NavigateFunction>;

export const useOpenDialog = (): OpenDialogFunction => {
    const location = useLocation();
    const navigate = useNavigate();

    return useCallback(
        function <TState>(modalName: string, state?: TState) {
            // Если како-то dialog уже открыт, то ничего не делаем
            if (
                location.state?.[DIALOG_STATE_KEY] &&
                !(
                    location.state[DIALOG_STATE_KEY] === DIALOGS.COLLECTION_STATUS &&
                    modalName === DIALOGS.EDIT_COLLECTION
                )
            ) {
                return;
            }

            return navigate(location.pathname, {
                state: { ...state, [DIALOG_STATE_KEY]: modalName },
            });
        },
        [location, navigate],
    );
};

interface DialogRouteProps {
    name: string;
    element: ReactElement;
}

export const DialogRoute = (props: DialogRouteProps) => {
    const { name, element } = props;
    const { state } = useLocation();

    if (state?.[DIALOG_STATE_KEY] === name) {
        return element;
    }

    return null;
};

export const useIsSomeDialogOpen = () => {
    const { state } = useLocation();

    return Boolean(state?.[DIALOG_STATE_KEY]);
};
